import { RouteComponentProps } from "react-router-dom";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { WSPage } from "@wingspanhq/fe-component-library";
import { queriesRequirements } from "@query";
import { WSQueries } from "../../../../query/WSQuery";

/**
 * The `:payerId` segment carries the payer's *account* id — that is what the
 * links into this route are built from (`notification.context.payer.payerId`).
 * A v3 `Payer.id` is a different thing (the composite
 * `<payerAccountId>_<payeeAccountId>` for a linked client), so the segment
 * cannot be handed to `getPayer`.
 *
 * Rather than reconstruct a `Payer.id` to read a record this screen barely uses,
 * no payer is read here at all. The client's name comes from the payer search
 * rows the requirements config already resolves by account id
 * (`getRequirementPayerName`), and the segment is all the back-link needs.
 *
 * That also removes a failure mode: `getPayer` and the requirement used to share
 * one `WSQueries`, and `WSQueries` renders the not-found empty state as soon as
 * *any* of its queries errors — so a payer 404 blanked the whole page even
 * though the requirement itself had resolved.
 */
export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payerId }
  }
}) => {
  const queryRequirement = queriesRequirements.getPayeeRequirement.useQuery({
    requirementId
  });

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryRequirement
        }}
      >
        {({ queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payerAccountId={payerId}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
